// extracted by mini-css-extract-plugin
export default {"error":"ErrorWindow_error__W0vP-","errorActive":"ErrorWindow_errorActive__fT-od"};